"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGlobalInstanceId = void 0;
var helper_1 = require("./helper");
var globalObj = (helper_1.isBrowser ? window : global);
globalObj.__dui_instance_counter__ = globalObj.__dui_instance_counter__ || {};
var counterMap = globalObj.__dui_instance_counter__;
function createGlobalInstanceId(type) {
    counterMap[type] = counterMap[type] || 0;
    counterMap[type]++;
    return "dui" + type + "Id-" + counterMap[type];
}
exports.createGlobalInstanceId = createGlobalInstanceId;
